export default __webpack_public_path__ + "static/media/background1.c2d57062.svg";